import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import Modal from 'react-modal';
import { format } from 'date-fns';
import FileIcon from '../../../assets/FileIcon';
import CustomPopupText from '../../shared/CustomPopupText';
import CustomButton from '../../shared/CustomButton';

const OverrideUploadData = ({ isOpen, close, handleOverride, startDate, type }) => {
  const [viewConfirm, setViewConfirm] = useState(isOpen);
  const [newDate, setNewdate] = useState('');
  const closePopup = () => {
    setViewConfirm(false);
    close();
  };
  useEffect(() => {
    const dateObj = new Date(startDate);

    if (type === 'monthly') {
      setNewdate(format(dateObj, 'MMMM'));
    } else if (type === 'yearly') {
      setNewdate(format(dateObj, 'yyyy'));
    } else {
      setNewdate(startDate);
    }
  }, [startDate, type]);
  return (
    <Modal
      isOpen={viewConfirm}
      onRequestClose={() => false}
      shouldCloseOnEsc={false}
      style={{
        overlay: { backgroundColor: 'hsla(50, 33%, 25%, 0.35)' },
        content: {
          display: 'flex',
          padding: '20px 16px 28px',
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          width: '320px',
          height: '230px',
          background: '#FFFFFF',
        },
      }}
    >
      <Grid container direction="column" justifyContent="center" alignItems="center">
        <Grid item>
          <Grid container direction="column" justifyContent="center" alignItems="center">
            <Grid item>
              <FileIcon />
            </Grid>
            <Grid item>
              <CustomPopupText
                text={`Data exists for ${newDate} already. You want to override it?`}
                fontSize="14px"
                fontWeight="700"
                lineHeight="19.32px"
                align="center"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container direction="row" alignItems="center">
            <Grid item style={{ marginRight: '10px' }}>
              <CustomButton type="secondary" size="medium" label="No" onClick={closePopup} />
            </Grid>
            <Grid item>
              <CustomButton type="primary" size="medium" label="Yes, Proceed" onClick={handleOverride} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};
export default OverrideUploadData;
